import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { CreateChannelModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/inputs/charge-point/create-channel.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { ChargePointChannelCreateFormStep1Controller } from '@app/feature/charge-point/charge-point-channel-create/charge-point-channel-create-form-step-1/charge-point-channel-create-form-step-1.controller';
import { useCreateChargePointChannelContext } from '@app/feature/charge-point/charge-point.context';

interface ChargePointChannelCreateFormControllerProps {
  onError: SubmitErrorHandler<
    Pick<CreateChannelModel, 'chargePointId' | 'channel'>
  >;
  onSubmit: SubmitHandlerWithDirtyFields<
    Pick<CreateChannelModel, 'chargePointId' | 'channel'>
  >;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const ChargePointChannelCreateFormController = (
  props: ChargePointChannelCreateFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useCreateChargePointChannelContext();

  return (
    <MultiStepFormProvider<
      Pick<CreateChannelModel, 'chargePointId' | 'channel'>
    >
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['channel.qrCode', 'channel.physicalSockets'],
          component: <ChargePointChannelCreateFormStep1Controller />,
        },
      ]}
    />
  );
};
